<template>
  <div class="user-avatar-dropdown">
    <Dropdown @on-click="handleClick">
      <Badge :dot="!!messageUnreadCount">
        <div class="user-info">
          <div>
            <h4>{{ this.$store.state.user.userName }}</h4>
            <h4>{{ this.$store.state.user.roleName }}</h4>
          </div>
        </div>
        <Avatar :src="userAvatar" />
      </Badge>
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <!-- <DropdownItem name="message">
                    消息中心<Badge style="margin-left: 10px" :count="messageUnreadCount"></Badge>
                </DropdownItem> -->
        <DropdownItem name="password">{{ $t("changePWd") }}</DropdownItem>
        <DropdownItem name="logout">{{ title }}</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <Modal v-model="password_m" :title="$t('changePWd')"
           :mask-closable="!this.$store.state.user.showUpdatePasswordModel"
           :closable="!this.$store.state.user.showUpdatePasswordModel">
      <Form :label-width="100">
        <FormItem :label="$t('newPwd')">
          <Input v-model="newpassword1" type="password"></Input>
        </FormItem>
        <FormItem :label="$t('confirmPwd')">
          <Input v-model="newpassword2" type="password"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button v-if="!this.$store.state.user.showUpdatePasswordModel" @click="cancel">{{ $t("cancel") }}</Button>
        <Button type="primary" @click="modificationpassword">{{
          $t("order_submit")
        }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import "./user.less";
import { updatePwd } from "@/api/user/internal";
import { mapActions } from "vuex";
export default {
  name: "User",
  props: {
    userAvatar: {
      type: String,
      default: "",
    },
    messageUnreadCount: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    this.password_m = this.$store.state.user.showUpdatePasswordModel
  },
  data() {
    return {
      langList: {
        "zh-CN": "退出登录",
        "en-US": "Log Out",
      },
      password_m: false,
      user: {},
      newpassword1: "",
      newpassword2: "",
    };
  },
  computed: {
    title() {
      return this.langList[this.$i18n.locale];
    },
  },

  methods: {
    ...mapActions(["handleLogOut"]),
    logout() {
      this.handleLogOut().then(() => {
        this.$router.push({
          name: "login",
          // query: {
          //   redirect: this.$route.name
          // }
        });
      });
    },
    password() {
      this.password_m = true;
    },
    cancel() {
      this.information_m = false;
      this.password_m = false;
    },
    modificationpassword(f) {
      if (this.newpassword1 !== this.newpassword2) {
        this.$Message.error("密码不一样");
        return;
      }
      updatePwd({
        id: this.$store.state.user.userId,
        hash_password: this.newpassword1,
      }).then((res) => {
        if (res.data.status) {
          this.$Message.success(res.data.msg);
          this.newpassword1 = this.newpassword2 = "";
          this.cancel();
        } else {
          this.$Message.error(res.data.msg);
        }
      });
    },
    handleClick(name) {
      switch (name) {
        case "logout":
          this.logout();
          break;
        case "message":
          this.message();
          break;
        case "password":
          this.password();
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.user-info {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
  div {
    display: flex;
    flex-direction: column;
    line-height: 25px;
  }
}
</style>
